import $ from "jquery";
import "popper.js"; // Bootstrap requires this
import "bootstrap";
//import "fslightbox";

import AOS from 'aos';
import 'aos/dist/aos.css';

import './js/text-animation.js'

import "./js/imagesloaded.pkgd.min.js";
import "./js/isotope.pkgd.min.js";
//import "./js/navigation.js";
import "./js/skip-link-focus-fix.js";
// import "./js/cycle2.min.js";
// import "./js/cycle2.center.min.js";
import "./js/site.js";

//import "./js/tiny-mce-button";

// Can import modules as needed
// ex. import 'bootstrap/js/dist/dropdown';

import "./scss/style.scss";

// # ---------------------------------------------------------------
// # Custom Methods...

(function ($) {

  $(function () {

    // Init AOS for scroll animations
    AOS.init();


    $("#menu-open-button, #menu-close-button").click(function () {
      $("#mobile-navigation").slideToggle('fast');
      $(this).toggleClass('nav-open');
      $('body').toggleClass('nav-open');
      // $('body').toggleClass('stop-scroll');
      if ($(this).hasClass('nav-open')) {
        $(this).attr('aria-expanded', 'true');
      } else {
        $(this).attr('aria-expanded', 'false');
      }
    });

    /* Scroll-to Animations */
    $('button.back-to-top').click(function (event) {
      event.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 100);
      return false;
    });

    /* Clients & Case Studies Scroll To */
    $('.case-study-scrollnav__link').click(function (event) {
      if ($(window).width() > 767) {
        event.preventDefault();

        // Ignore if we are already there
        if ($(this).hasClass('active')) {
          return;
        }

        // Toggle active classes
        $('.case-study-scrollnav__link').each(function () {
          $(this).removeClass('active');
        });
        $(this).addClass('active');

        // Get the client ID
        let clientID = $(this).attr('href');

        $(".client-preview-wrap").animate(
          {
            scrollTop:
              $(".client-preview-wrap").scrollTop() +
              $(clientID).position().top - 170
          },
          1000
        );
      }
    });
    /* END Clients & Case Studies Scroll To */

    /* Dropdown Nav Hover */
    // $('li.menu-item-has-children').hover( function(){
    //   $(this).children('.sub-menu').show();
    // });

    /* END Dropdown Nav Hover */


    // $(document).ready(function () {

    // });

  });
})($);
